export const LocationConstants = {
  // Route Tokens
  defaultApi: 'Location',

//  APPLICATION: "application",
//  GROUP: "group",
//  OLDER_THAN: "olderThan",
//  ROLES: "roles",

  // Other constants
    UI: {
    ROOT_PATH: 'location',
  }

} as const;
